import { myFetch, HttpMethod } from './baseService';

// Interfaz para tipo de documento
export interface TipoDocumento {
  tdo_code: string;
  tdo_nombre: string;
  tdo_estatus: string;
  tdo_estatus_nombre: string;
}

// Interfaz para la respuesta de la API
export interface TipoDocumentoResponse {
  code: string;
  message: string;
  object_: TipoDocumento[];
}

// Función para obtener todos los tipos de documento
export const obtenerTiposDocumento = async () => {
  const response = await myFetch<TipoDocumentoResponse>(
    'tipo_documento/ObtenerTodos',
    HttpMethod.POST,
    {}
  );

  return response;
};
